import React from "react";
import { STATUS_CONFIG } from "../../services/MailingListService";

/**
 * ContactStatusBadge - Status badge for contact delivery status
 */
const ContactStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${config.bgClass} ${config.textClass}`}
    >
      {config.label}
    </span>
  );
};

export default ContactStatusBadge;
